import React from "react";

// material-ui components

import { Box, CircularProgress } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import { useTranslation } from "react-i18next";


const useStyles = makeStyles(styles);


export default function LoadingModal({ open }) {

    const { t } = useTranslation("bulk-upload")
    const [, setIsSubmitting] = React.useState(false);

    React.useEffect(() => {
        setIsSubmitting(false);
      }, []);


      const classes = useStyles();

      return (
        <div>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal,
            }}
            open={open}
            keepMounted
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description"
          >

            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
            >
                <Box display="flex" flexDirection={"column"} justifyContent="center" alignItems="center" height="100%" marginTop="16px" width="400px">
                    <CircularProgress size="48px" />
                    <h3>{t("sending")}</h3>
                </Box>
            </DialogContent>
          </Dialog>
        </div>
      );





}
